import React, { useState } from 'react';
import { AutoEstimateWidget } from '../../auto-estimate';
import InquiryModal from '../../components/features/InquiryModal';
import './Estimate.css';

const Estimate = () => {
    // Modal state kept if we want to trigger it from Widget later, 
    // but Widget currently handles its own flow.
    // For now, we just render the Widget.
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className="estimate-page">
            <InquiryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} type="ESTIMATE" />

            {/* <div className="page-hero">
                <div className="container">
                    <h1 className="page-title">예상 견적 산출</h1>
                    <p className="page-subtitle">
                        몇 가지 질문에 답해주시면,<br />
                        즉시 예상 견적 범위를 확인하실 수 있습니다.
                    </p>
                </div>
            </div> */}

            <div className="container">
                {/* Auto Estimate Widget Area */}
                <div style={{ margin: '40px 0' }}>
                    <AutoEstimateWidget />
                </div>

                <div style={{ textAlign: 'center', marginTop: '4rem', color: '#888', fontSize: '0.9rem' }}>
                    * 산출된 견적은 예상 범위이며, 실제 상황에 따라 달라질 수 있습니다.<br />
                    * 상세한 견적은 '문의하기'를 통해 상담받으실 수 있습니다.
                </div>
            </div>
        </div>
    );
};

export default Estimate;
